import { _js } from '@ifixit/localize';
import * as React from 'react';
import { ListNum } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const OrderedListButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleOrderedList().run()}
         isActive={editor.isActive('orderedList')}
         isDisabled={!editor.can().toggleOrderedList()}
         icon={<ListNum />}
         title={_js('Add a numbered list')}
         shortcut={'shift+7'}
      />
   );
};
